import angular from 'angular'

const listPage = require('./view/list.html')
const listCtrl = require('./list')
const detailPage = require('./view/detail.html')
const relatedBillInvoicePage = require('./view/relatedBill_invoice.html')
const openedRelatedBillCtrl = require('./openedRelatedBillCtrl')

const openedFullEleInvoiceChooseUkeyModal = require('./openedFullEleInvoiceChooseUkeyModal')

function configRouter($stateProvider) {
    $stateProvider.state('outputManage.fullElectricInvoice.openedFullEleInvoice', {
        url: '/openedFullEleInvoice',
        abstract: true,
        template: '<div ui-view></div>',
        default: 'outputManage.fullElectricInvoice.openedFullEleInvoice.list',
        title: '已开全电票',
    })
    $stateProvider.state('outputManage.fullElectricInvoice.openedFullEleInvoice.list', {
        url: '/list',
        template: listPage,
        controller: 'listCtrl',
    })
    $stateProvider.state('outputManage.fullElectricInvoice.openedFullEleInvoice.detail', {
        url: '/detail/:invoiceId/:invType',
        template: detailPage,
        controller: 'fullElectricInvoiceEditCtrl',
        title: '电子票详情',
        params: {
            detailFlag: true,
        },
    })
    $stateProvider.state('outputManage.fullElectricInvoice.openedFullEleInvoice.relatedBill', {
        url: '/relatedBill/:invoiceId',
        template: relatedBillInvoicePage,
        controller: 'openedRelatedBillCtrl',
        title: '关联销售单',
    })
}

export default angular
    .module('outputManage.fullElectricInvoice.openedFullEleInvoice', [])
    .config(['$stateProvider', configRouter])
    .controller('listCtrl', listCtrl.default)
    .controller('openedRelatedBillCtrl', openedRelatedBillCtrl.default)
    .controller('openedFullEleInvoiceChooseUkeyModal', openedFullEleInvoiceChooseUkeyModal.default).name



// WEBPACK FOOTER //
// ./src/app/outputManage/fullElectricInvoice/openedFullEleInvoice/index.js